import { AppSettingsActionTypes } from './appSettings.interfaces';

export const appSettingsActionTypes: AppSettingsActionTypes = {
  LOAD_APPSETTINGS_START: '[appSettings] LOAD_APPSETTINGS_START',
  LOAD_APPSETTINGS_SUCCESS: '[appSettings] LOAD_APPSETTINGS_SUCCESS',
  LOAD_APPSETTINGS_FAILURE: '[appSettings] LOAD_APPSETTINGS_FAILURE',
};

export const TAKE_NAEP_NOW_URL_DEFAULT = 'http://poseidonaws.ets-naepanalysis-prod.c.ets.org/takenaepnow_dev';